import { Injectable } from '@angular/core';
import { ChartFilterHandlerService } from './chart-filter-handler.service';

@Injectable({
  providedIn: 'root',
})
export class CustomChartFilterHandlerService extends ChartFilterHandlerService {
  /**
   * Overrides the updateFilterSelection.
   * Call specific custom logic here if needed, or fall back to super implementation.
   */
  override updateFilterSelection(data: any, name: string | any | any[], clickedRawData?: any): void {
    // --------------------------------------------------------------------------------
    // OPTIONAL: Add custom pre-processing logic here before calling the base method.
    // e.g., modifiedName = transform(name);
    // --------------------------------------------------------------------------------

    console.log(
      '[CustomChartFilterHandler] Delegating to base ChartFilterHandlerService',
      { data, name },
    );

    super.updateFilterSelection(data, name, clickedRawData);

    // --------------------------------------------------------------------------------
    // OPTIONAL: Add custom post-processing logic here.
    // --------------------------------------------------------------------------------
  }
}
